export default {
  submitBtn: false,
  emptyBtn: false,
  column: [
    {
      label: '租户名称',
      prop: 'name',
      disabled: true,
    },
    {
      label: '联系电话',
      prop: 'mobile',
      disabled: true,
    },
    {
      label: '性别',
      prop: 'sex',
      type: 'select',
      dataType: 'number',
      dicUrl: 'api/blade-system/dict/dictionary?code=sex',
      props: { label: 'dictValue', value: 'dictKey' },
      disabled: true,

    },
    {
      label: '身份证',
      prop: 'idCard',
      disabled: true,
    },
    {
      label: '工作单位',
      width: 150,
      prop: 'companyName',
      type: 'tree',
      dicUrl: 'api/v4ward/departmentCompany/getDepartmentCompanyList',
      props: { label: 'companyName', value: 'id' },
      disabled: true,
    },
    {
      label: '修改人',
      prop: 'updateUserName',
      disabled: true,
    },
    {
      prop: 'test',
      label: '',
      formslot: true,
      labelslot: true,
      span: 24,
      row:true,
    },
  ],
};
